module.exports = [
  {
    name: {
      zh: 'HUGO BANDEIRA',
      en: 'HUGO BANDEIRA',
    },
    title: {
      zh: '餐飲課程主任<br/>葡萄牙',
      en: 'Coordinator for Food and Beverage Courses, Portugal',
    },
    description: {
      zh: 'Hugo Bandeira先生於旅遊學院畢業，並獲取英國葡萄酒及烈酒教育信託WSET®認證導師資格。他經常在國際葡萄酒比賽中出任裁判，也是土生葡人美食聯誼會的創始會長。',
      en: 'Mr. Bandeira is a graduate of IFT and a tutor approved by the Wine and Spirit Education Trust (WSET®) in Britain. He regularly serves as a judge in international wine competitions and was the Founding President of the Macanese Gastronomy Association.',
    },
    image: '/images/tourism/team-06.jpg',
  },
  {
    name: {
      zh: 'LAURIE ANNE BAKER-MALUNGU',
      en: 'LAURIE ANNE BAKER-MALUNGU',
    },
    title: {
      zh: '論文 / 計劃書實習課程協調員<br/>美國',
      en: 'Regent for Thesis and Projects,<br/> United States of America',
    },
    description: {
      zh: 'Baker-Malungu博士是教育專家。擁有三十多年教學經驗，曾於中國台灣、中國廣西和澳門的高等教育機構工作。目前，她在旅遊學院負責協調日間理學學士學位課程的研究論文/項目畢業要求，Baker-Malungu博士致力於為學生創造學習體驗，學生從而學習必要的知識和技能，以向行業專家展示受所認可的能力。她的研究興趣包括電子學習、語言習得、職業發展、課程設計和職業效能。',
      en: 'Dr. Baker-Malungu is a specialist in the field of education. For more than 30 years she has served in institutions of higher education in Chinese Taiwan, in Guangxi and in Macao. In charge of overseeing the Thesis/Project graduation requirement for the daytime BSc degree programmes, Dr. Baker-Malungu is committed to creating learning experiences that give students the knowledge and skills necessary to demonstrate capacity that can be recognised by expert peers. Her research interests include e-learning, language acquisition, occupational development, curriculum design and occupational efficacy.',
    },
    image: '/images/tourism/team-07.jpg',
    textLength: 260,
  },
  {
    name: {
      zh: 'MIGUEL GASSMANN DE OLIVEIRA',
      en: 'MIGUEL GASSMANN DE OLIVEIRA',
    },
    title: {
      zh: '餐廳及酒吧實習課程協調員<br/>葡萄牙',
      en: 'Regent for Restaurant and Bar Courses, Portugal',
    },
    description: {
      zh: 'Gassmann de Oliveira先生教授與餐廳及酒吧營運有關的學科，內容包括成本控制和食材準備。他於旅遊學院畢業，在加入學院的教學團隊前，曾於澳門酒店任職超過10年。',
      en: 'Mr. Gassmann de Oliveira teaches courses on aspects of running restaurants and bars, including cost control and food preparation. Mr. Gassmann de Oliveira is an IFT graduate who worked in the hotel business in Macao for more than a decade before returning to teach at the Institute.',
    },
    image: '/images/tourism/team-08.jpg',
  },
  {
    name: {
      zh: '何文正',
      en: 'OSCAR HO',
    },
    title: {
      zh: '一、二年級校外實習課程協調員及<br/>三年級實習課程協調員<br/>澳門',
      en: 'Regent for Off-Campus Practicum and Regent for Internship, Macao',
    },
    description: {
      zh: '何文正先生在大中華地區擁有豐富的業務發展經驗，負責協調旅遊學院的實習課程，也統籌多項讓學生在旅遊和零售範疇實習的計劃。',
      en: 'Mr. Ho coordinates the IFT curricular internship programme, putting to use his extensive experience of business development in Greater China. Mr. Ho also supervises schemes that give students experience of working under supervision in tourism and retailing.',
    },
    image: '/images/tourism/team-09.jpg',
  },
  {
    name: {
      zh: '葉嘉儀',
      en: 'DORIS IP',
    },
    title: {
      zh: '語言實習課程協調員<br/>澳門',
      en: 'Regent for Languages, Macao',
    },
    description: {
      zh: '葉嘉儀副教授自旅遊學院成立之初便加入團隊，負責英語教學，以及協調英語和其他語言選修課程，其研究興趣包括課程設計和語言學習動機。她曾為澳門的士司機編制一套旅遊英語學習教材。',
      en: 'Assistant Professor Ms. Ip has been at IFT since its establishment, specialising in language teaching. She teaches English courses and oversees English and other language courses. Ms. Ip’s research interests include curriculum design and language-learning motivation. She is a joint author of an English language audio course for taxi drivers.',
    },
    image: '/images/tourism/team-10.jpg',
  },
  {
    name: {
      zh: '黃文樹',
      en: 'WONG MAN SU',
    },
    title: {
      zh: '廚房實習課程協調員<br/>澳門',
      en: 'Regent for Kitchen Courses, Macao',
    },
    description: {
      zh: '主廚黃文樹自旅遊學院成立之初便加入團隊。此前，在80年代至90年代期間，曾在葡京酒店餐飲部任職。他最先學習的是日式料理創作，期後學習了不同的烹調風格，包括土生菜、葡國菜及西式料理。',
      en: 'Chef Wong was trained in the preparation of Japanese food and added to his skills at Hotel Lisboa in the 1980s and early 1990s. He also masters other kinds of cuisine, including Macanese cuisine and Western cuisine. Chef Wong has been at IFT since its establishment.',
    },
    image: '/images/tourism/team-11.jpg',
  },
  {
    name: {
      zh: '胡振華',
      en: 'BENNY VU',
    },
    title: {
      zh: '餐廳及酒吧實習課程協調員<br/>澳門',
      en: 'Regent for Restaurant and Bar Courses, Macao',
    },
    description: {
      zh: '胡振華先生自1998年起擔任旅遊學院教學餐廳經理，協調學士學位課程學生在旅遊學院教學餐廳的實習課程。在加入學院前，他曾在澳門酒店業擔任不同的管理職位。胡振華先生也是“澳門職業技能認可基準”（MORS）培訓導師和評核員。',
      en: 'Mr. Vu has been the Manager of the IFT Educational Restaurant since 1998 and assists in the supervision of undergraduate practicums at the restaurant. Prior to joining IFT, Mr. Vu held managerial positions in the hospitality industry in Macao. He is a trainer and assessor in the Macao Occupational Skills Recognition System.',
    },
    image: '/images/tourism/team-12.jpg',
  },
]
